import React, { useEffect } from 'react';
import { Button } from '../components/ui/Button';
import { useDrawers } from '../contexts/DrawerContext';
import { Phone, Mail, MapPin, Clock, FileText } from 'lucide-react';
export function Contact() {
  const {
    openUpload,
    openQuote
  } = useDrawers();
  useEffect(() => {
    document.title = 'Contact L.A Property Law | Carlton Melbourne';
    window.scrollTo(0, 0);
  }, []);
  return <main data-id="element-618">
      <section className="px-5 md:px-6 pt-12 md:pt-20 pb-16 md:pb-24 bg-background" data-id="element-619">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-10 lg:gap-12 items-start" data-id="element-620">
          <div className="lg:col-span-6" data-id="element-621">
            <p className="font-script text-2xl text-accent mb-1" data-id="element-622">
              get in touch
            </p>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-ink leading-[1.08]" data-id="element-623">
              Tell us about your property matter.
            </h1>
            <p className="mt-5 text-lg text-muted-ink leading-relaxed max-w-xl" data-id="element-624">
              Send your contract for review or request a quote. Include any
              auction, offer or signing deadline so the team can assess how
              quickly your matter needs to move.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-3" data-id="element-625">
              <Button onClick={openUpload} variant="accent" size="lg" data-id="element-626">
                <FileText className="w-5 h-5" data-id="element-627" />
                Upload a contract
              </Button>
              <Button onClick={openQuote} variant="outline" size="lg" data-id="element-628">
                Get a free quote
              </Button>
            </div>
          </div>

          <div className="lg:col-span-6" data-id="element-629">
            <div className="rounded-3xl bg-surface border border-border shadow-card p-7 md:p-9" data-id="element-630">
              <h2 className="font-serif text-2xl text-ink mb-6" data-id="element-631">
                L.A Property Law & Conveyancing
              </h2>
              <ul className="space-y-5" data-id="element-632">
                <li className="flex items-start gap-4" data-id="element-633">
                  <span className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full bg-accent-soft text-accent" data-id="element-634">
                    <MapPin className="w-5 h-5" data-id="element-635" />
                  </span>
                  <div data-id="element-636">
                    <p className="text-ink font-medium" data-id="element-637">
                      202 Elgin Street, Carlton VIC 3053, Australia
                    </p>
                    <a href="https://maps.google.com/?q=202+Elgin+Street+Carlton+VIC+3053" target="_blank" rel="noopener noreferrer" className="text-brand-blue font-semibold hover:underline" data-id="element-638">
                      View on Google Maps
                    </a>
                  </div>
                </li>
                <li className="flex items-start gap-4" data-id="element-639">
                  <span className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full bg-accent-soft text-accent" data-id="element-640">
                    <Phone className="w-5 h-5" data-id="element-641" />
                  </span>
                  <a href="tel:+61386172600" className="text-ink font-medium hover:text-accent transition-colors" data-id="element-642">
                    (03) 8617 2600
                  </a>
                </li>
                <li className="flex items-start gap-4" data-id="element-643">
                  <span className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full bg-accent-soft text-accent" data-id="element-644">
                    <Mail className="w-5 h-5" data-id="element-645" />
                  </span>
                  <a href="mailto:hello@lapropertylaw.com.au" className="text-ink font-medium hover:text-accent transition-colors break-all" data-id="element-646">
                    hello@lapropertylaw.com.au
                  </a>
                </li>
                <li className="flex items-start gap-4" data-id="element-647">
                  <span className="shrink-0 inline-flex items-center justify-center w-10 h-10 rounded-full bg-accent-soft text-accent" data-id="element-648">
                    <Clock className="w-5 h-5" data-id="element-649" />
                  </span>
                  <div className="text-ink" data-id="element-650">
                    <p className="font-medium" data-id="element-651">Mon-Fri 9:00am-5:00pm</p>
                    <p className="text-muted-ink text-sm mt-0.5" data-id="element-652">
                      Office visits by appointment only
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </main>;
}